import {Suspense} from "react";
import {useAuth} from "@hooks/useAuth.tsx";
import {Box, Paper, Progress} from "@mantine/core";
import {AppHeader} from "@components/default/AppHeader.tsx";
import {BreadcrumbsComponent} from "@components/default/BreadcrumbsComponent.tsx";
import {Outlet} from "react-router";
import {LoginPage} from "@components/account/LoginPage.tsx";

export const Layout = () => {
	const {isAuthenticated} = useAuth();

	return (
		<Box style={{display: "flex", flexDirection: "column", minHeight: "100vh"}}>
			<Box w="100%">
				<AppHeader />
			</Box>

			<Box className="app-routes-container" w="100%">
				<Box mt="sm" px="md" pb="md" style={{flexGrow: 1}} w="100%">
					{isAuthenticated && <BreadcrumbsComponent />}

					<Paper
						withBorder
						p="md"
						radius="sm"
						w="100%"
						style={{
							opacity: 0.96,
							backgroundColor: "var(--mantine-color-body)",
						}}
					>
						<Box w="100%">
							{isAuthenticated ? (
								<Suspense fallback={<Progress size="xs" value={100} animated color="primary" w="100%" />}>
									<Outlet />
								</Suspense>
							) : (
								<LoginPage />
							)}
						</Box>
					</Paper>
				</Box>
			</Box>
		</Box>
	);
};